/**
 * Permission identifiers for the HR module.
 *
 * Mirrors apps/api/src/auth/services/module-catalog.ts so frontend gating
 * cannot diverge from backend RBAC.
 */
import { hasAnyPermission, hasPermission } from './crmPermissions';

export { hasAnyPermission, hasPermission };

export const HR_PERMISSIONS = {
  READ: 'hr:read',
  IMPORT_READ: 'hr_import:read',
  IMPORT_WRITE: 'hr_import:write',
  ATTENDANCE_READ: 'hr_attendance:read',
  ATTENDANCE_WRITE: 'hr_attendance:write',
  CANDIDATE_READ: 'hr_candidate:read',
  CANDIDATE_WRITE: 'hr_candidate:write',
  INTERVIEW_READ: 'hr_interview:read',
  INTERVIEW_WRITE: 'hr_interview:write',
  TRAINING_READ: 'hr_training:read',
  TRAINING_WRITE: 'hr_training:write',
  // Issue #362 — HR credential / certificate expiry + login freeze.
  CERTIFICATE_READ: 'hr_certificate:read',
  CERTIFICATE_WRITE: 'hr_certificate:write',
  CERTIFICATE_REVIEW: 'hr_certificate:review',
  // Issue #363 — HR offboarding lifecycle + handoff + payroll hold.
  OFFBOARDING_READ: 'hr_offboarding:read',
  OFFBOARDING_WRITE: 'hr_offboarding:write',
  OFFBOARDING_REVIEW: 'hr_offboarding:review',
  OFFBOARDING_PAYROLL_REVIEW: 'hr_offboarding:payroll_review',
} as const;

export function canSeeHrMenu(permissions: readonly string[]): boolean {
  return hasAnyPermission(permissions, [
    HR_PERMISSIONS.READ,
    HR_PERMISSIONS.IMPORT_READ,
    HR_PERMISSIONS.ATTENDANCE_READ,
    HR_PERMISSIONS.CANDIDATE_READ,
    HR_PERMISSIONS.INTERVIEW_READ,
    HR_PERMISSIONS.TRAINING_READ,
    HR_PERMISSIONS.CERTIFICATE_READ,
    HR_PERMISSIONS.OFFBOARDING_READ,
  ]);
}
